import { render, staticRenderFns } from "./EditInstitute.vue?vue&type=template&id=6ce433d6&lang=true"
import script from "./EditInstitute.vue?vue&type=script&lang=js"
export * from "./EditInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports